<template>
  <div class="echarts" ref="el"></div>
</template>
<script>
// import * as echarts from 'echarts'
import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/dataset'
// import 'echarts/lib/chart/pie'
// import 'echarts/lib/chart/scatter'
// import 'echarts/lib/chart/radar'
// import 'echarts/lib/chart/map'
// import 'echarts/lib/chart/tree'
// import 'echarts/lib/chart/treemap'
// import 'echarts/lib/chart/graph'
// import 'echarts/lib/chart/gauge'
// import 'echarts/lib/chart/funnel'
// import 'echarts/lib/chart/parallel'
// import 'echarts/lib/chart/sankey'
// import 'echarts/lib/chart/boxplot'
// import 'echarts/lib/chart/candlestick'
// import 'echarts/lib/chart/effectScatter'
// import 'echarts/lib/chart/lines'
// import 'echarts/lib/chart/heatmap'
// import 'echarts/lib/chart/pictorialBar'
// import 'echarts/lib/chart/themeRiver'
// import 'echarts/lib/chart/sunburst'
// import 'echarts/lib/chart/custom'
// import 'echarts/lib/component/grid'
// import 'echarts/lib/component/polar'
// import 'echarts/lib/component/geo'
// import 'echarts/lib/component/singleAxis'
// import 'echarts/lib/component/parallel'
// import 'echarts/lib/component/calendar'
// import 'echarts/lib/component/graphic'
// import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/axisPointer'
// import 'echarts/lib/component/brush'
// import 'echarts/lib/component/timeline'
// import 'echarts/lib/component/markPoint'
// import 'echarts/lib/component/markLine'
// import 'echarts/lib/component/markArea'
// import 'echarts/lib/component/legendScroll'
// import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoomInside'
// import 'echarts/lib/component/dataZoomSlider'
// import 'echarts/lib/component/visualMap'
// import 'echarts/lib/component/visualMapContinuous'
// import 'echarts/lib/component/visualMapPiecewise'
// import 'zrender/lib/vml/vml'
// import 'zrender/lib/svg/svg'
export default {
  props: {
    echartTitle: String,
    xData: Array,
    yData: Array,
    height: {
      type: Number,
      default: 400
    }
  },
  watch: {
    xData: function(newVal, oldVal) {
      this.initEcharts()
    },
    yData: function(newVal, oldVal) {
      this.initEcharts()
    }
  },
  mounted() {
    this.initEcharts()
  },
  methods: {
    initEcharts() {
      // let isZoom = false
      // if (this.xData.length > 40) {
      //   isZoom = true
      // } else {
      //   isZoom = false
      // }
      for (var j = 0; j <= this.xData.length - 1; j++) {
        for (var i = 0; i <= this.xData.length - 1; i++) {
          if (this.xData[i] > this.xData[i - 1]) {
              var tmp = this.xData[i]
              this.xData[i] = this.xData[i - 1]
              this.xData[i - 1] = tmp
          }
        }
      }
      const myChart = echarts.init(this.$refs.el)
      myChart.setOption({
        title: {
          text: '风险排行',
          subtext: '敏感词排行'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          left: 'right'
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            endValue: 9,
            realtime: true,
            height: 9,
            left: 5,
            right: 5,
            bottom: 0,
            fillerColor: '#e9edf5',
            borderRadius: 34,
            borderColor: '#fff',
            backgroundColor: '#fff',
            handleSize: 0,
            showDetail: false,
            zoomLock: false,
            moveOnMouseMove: false,
            emphasis: {
              handleStyle: {
                color: 'rgba(255,255,255,1)'
              },
              moveHandleStyle: {
                color: 'rgba(222, 252, 26, 1)'
              }
            }
          }
        ],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              var ret = ''
              var max = 8
              var val = value.length
              var rowN = Math.ceil(val / max)
              if (rowN > 1) {
                for (var i = 0; i < rowN; i++) {
                  var temp = ''
                  const start = i * max
                  var end = start + max
                  temp = value.substring(start, end) + '\n'
                  ret += temp
                }
                return ret
              } else {
                return value
              }
            }
            // rotate: -45
          },
        //  max: 20,
          data: this.yData
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.1]
        },
        series: [
          {
            name: '敏感词数量',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              color: '#85A5FF'
            },
            data: this.xData
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>
